<template>
    <div>
        <div style="text-align:center;">
          <img src="https://aloha.crm-ideal.fr/img/logo_ideal_hor.png" alt="support" style="width:25%;"/>
        </div>
      <div style="text-align:center;">
        Merci de vous être inscrit,
        <br/>
        Nous vous remercions de l'intérêt que vous portez aux solutions Ideal 360.
        <br/>
        Nous revenons vers vous le plus rapidement possible pour affiner votre besoin.
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
</style>
